import { useQuery } from "@tanstack/react-query";
import {
  getBaselineSummary,
  getAllBaselines,
  getBaselineRankings,
  getStateBaselines,
  getBaselineSnapshot,
  type BaselineMetric,
} from "../../../api/baseline";

export function useGridBaseline(baCode: string | null | undefined) {
  return useQuery({
    queryKey: ["gridBaseline", baCode],
    queryFn: () => getBaselineSummary(baCode!),
    enabled: !!baCode,
    staleTime: 10 * 60_000,
    gcTime: 30 * 60_000,
  });
}

export function useAllBaselines() {
  return useQuery({
    queryKey: ["gridBaselines"],
    queryFn: () => getAllBaselines(),
    staleTime: 10 * 60_000,
    gcTime: 30 * 60_000,
  });
}

export function useBaselineRankings(metric: BaselineMetric = "carbon_intensity_kg_per_mwh", enabled: boolean = true) {
  return useQuery({
    queryKey: ["gridRankings", metric],
    queryFn: () => getBaselineRankings(metric),
    enabled,
    staleTime: 10 * 60_000,
    gcTime: 30 * 60_000,
  });
}

export function useStateBaselines() {
  return useQuery({
    queryKey: ["stateBaselines"],
    queryFn: () => getStateBaselines(),
    staleTime: 10 * 60_000,
    gcTime: 30 * 60_000,
  });
}

export function useBaselineSnapshot() {
  return useQuery({
    queryKey: ["baselineSnapshot"],
    queryFn: () => getBaselineSnapshot(),
    staleTime: 10 * 60_000,
    gcTime: 30 * 60_000,
  });
}
